import { useWidgetStore, WidgetID } from '@/widget-store';
import { useEffect } from 'react';

interface UseListenerParams {
  id: WidgetID;
  listenerFn: (data: any) => void;
  type: string;
}

export function useListener({ id, listenerFn, type }: UseListenerParams): {
  enabled: boolean;
  removeMessage: () => void;
} {
  const widget = useWidgetStore((state) => state.widgets[id]);
  const removeMessageFromStore = useWidgetStore((state) => state.removeMessage);
  const enabled = !!(widget?.messages && widget?.emitters);

  useEffect(() => {
    if (!widget?.messages?.length) return;

    let handled = false;

    widget.messages.forEach((message) => {
      if (message.type === type) {
        handled = true;
        listenerFn(message.data);
      }
    });

    if (handled) {
      removeMessageFromStore(id);
    }
  }, [widget?.messages, type, id, listenerFn, removeMessageFromStore]);

  function removeMessage() {
    removeMessageFromStore(id);
  }

  return { enabled, removeMessage };
}
